import Lottie from 'lottie-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { getdateFormat } from '../../../../base/utils';
import { initialStateModel, LoginState } from '../../../../models/model';
 import groovyWalkAnimation1 from "../../../../styles/images/delivery_1nd_tick.json";
import groovyWalkAnimation2 from "../../../../styles/images/delivery_2nd_tick.json";

import styles from "./chatgifinfo.module.scss";

type userDetails = {
  userDetails: any;
  timeStamp: any;
  message: any;
  isPopup?: boolean;
};

export default function ChatGifInfo({ userDetails, timeStamp, message, isPopup }: userDetails) {
  const { userdetails }: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  let isBookmark = message && message?.message?.isSave;
  let hovertimestamp = timeStamp !== undefined ? getdateFormat(timeStamp) : "";
  
  return (
    <>
          <div className={styles.convTime}>
            {(!(isBookmark) || isBookmark['s' + userdetails?.sip_login_id]) === 1? (<span className={styles.addBookData}><span className="icon_ribbonfill">
              </span>
              </span>):null}
            <span>{hovertimestamp}</span>
            { message.direction==="OUT" && <>
        {message.deliveryStatus  === 8 && message.readStatus === 1 && message.message.isDelete ? (
          ""
        ) : message.deliveryStatus  === 8 && message.readStatus === 1 ? (
          <span className="readMsg fadeIn"></span>
        ) : message.deliveryStatus  === 8 && message.readStatus === 0 && message.message.isDelete ? (
          ""
        ) : message.deliveryStatus  === 8 && message.readStatus === 0 ? (
          <Lottie className="svgsendtick"
          animationData={groovyWalkAnimation2} loop={false}/> 
        ) : message.deliveryStatus  === 4 && message.message.isDelete ? (
          ""
        ) : message.deliveryStatus  === 4 ? (
          <Lottie className="svgsendtick"
            animationData={groovyWalkAnimation1} loop={false}/>
        ) : message.deliveryStatus  === 2 && message.message.isDelete ? (
          ""
        ) : message.deliveryStatus  === 2 ? (
          <span className="iconTimer"></span>
        ) : (
          <span className="iconTimer"></span>
        )}
   </>}
                </div>
     </>
  );
}
